import Icon from "@components/global/new/Icon/Icon";
import { makeColor } from "@utils/hexToRgb";
import styles from "./ColoredClient.module.scss";

import origEdit from "@assets/redesign/icons/inputEdit.svg";
import TooltipText from "@components/global/new/TooltipText/TooltipText";
import { MODALS_ENUM } from "@constants/Modals";
import mainLocationsStore from "@mobx/store/locations";
import { IColoredUser3 } from "@mobx/store/locations/types";
import { Checkbox } from "antd";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { WLP202603 } from "../../../config";
import wlpEdit from "@components/WLP202603/assets/redesign/icons/inputEdit.svg";

const edit = WLP202603 ? wlpEdit : origEdit;

export interface IColoredClient3Props extends IColoredUser3 {}

const useControl = (
  props: IColoredClient3Props
) => {
  const locationStore = mainLocationsStore.activeLocation;
  const dispatch = useDispatch();

  const onEdit = () => {
    dispatch(
      show(MODALS_ENUM.EDIT_CLIENT_COLOR, {
        client: props,
      })
    );
  };

  const isActive = useMemo(() => {
    return locationStore?.selectedUsers.has(props.id);
  }, [locationStore?.selectedUsers]);

  const onSelectClient = () => locationStore?.toggleUserSelection(props.id);

  return {
    isActive,

    onEdit,
    onSelectClient,
  };
};

const ColoredClient3 = observer((props: IColoredClient3Props) => {
  const { color, name, email } = props;
  const control = useControl(props);

  return (
    <div className={styles.wrapper}>
      <TooltipText
        text={name || email}
        open={(name || email).length > 10 ? undefined : false}
      >
        <div className={styles.content} style={{ backgroundColor: color }}>
          <Checkbox
            checked={control.isActive}
            onClick={control.onSelectClient}
          />
          <p style={{ color: makeColor(color) }}>{name || email}</p>
        </div>
      </TooltipText>
      <Icon src={edit} className={styles.edit_icon} onClick={control.onEdit} />
    </div>
  );
});

ColoredClient3.displayName = "ColoredClient3";

export default ColoredClient3;
